module.exports = __webpack_public_path__ + "static/img/755_phase_function_Paper_PointsHejduk_Prediction.65f164b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/755_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Rcho
// module chunks = 0